import type { BuildingId, UnitId } from "./content/buildings.js";

export const QUEUE_KINDS = ["construction", "restoration", "assembly"] as const;
export type QueueKind = (typeof QUEUE_KINDS)[number];

export interface ManufacturingOrder {
  readonly id: string;
  readonly target: BuildingId | UnitId;
  readonly quantity: string;
  readonly remaining: string;
  readonly repeat: boolean;
}

export interface ManufacturingState {
  readonly nextOrderId: number;
  readonly construction: readonly ManufacturingOrder[];
  readonly restoration: readonly ManufacturingOrder[];
  readonly assembly: readonly ManufacturingOrder[];
  readonly paused: Readonly<Record<QueueKind, boolean>>;
  readonly factoryWorksRetoolUntilMs: number;
}

export interface ConstructionSplit {
  readonly newConstruction: number;
  readonly restoration: number;
}
